import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Gallery } from './pages/Gallery';
import { Financing } from './pages/Financing';
import { Quote } from './pages/Quote';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  useEffect(() => {
    document.title = 'THE EP INC';
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="2mm2ji848kh09">
      <Layout data-id="element-1" data-mp="2mmvkstkfeeb0">
        <Routes data-id="element-2" data-mp="2mn59mdtqiff4">
          <Route path="/" element={<Home data-id="element-4" data-mp="31aqdwb2cikom" />} data-id="element-3" data-mp="2mnngs5hxqe1t" />
          <Route path="/about" element={<About data-id="element-6" data-mp="31bi9hlvy0iew" />} data-id="element-5" data-mp="31b8l22qjqjbb" />
          <Route path="/gallery" element={<Gallery data-id="element-8" data-mp="2wka18t6cn33b" />} data-id="element-7" data-mp="31c1ksjr388jy" />
          <Route path="/financing" element={<Financing data-id="element-10" data-mp="2wip6b2g4hi4x" />} data-id="element-9" data-mp="2wjqft2hhpwkj" />
          <Route path="/quote" element={<Quote data-id="element-12" data-mp="28tw9l3rof699" />} data-id="element-11" data-mp="2wi5qbra193tj" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}